var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDropDownArrow(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 13.105,
    height: 7.502,
    viewBox: "0 0 13.105 7.502",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_ionic-ios-arrow-down",
    "data-name": "Icon ionic-ios-arrow-down",
    d: "M12.751,16.488l4.962-4.966a.934.934,0,0,1,1.324,0,.946.946,0,0,1,0,1.328l-5.622,5.626a.936.936,0,0,1-1.293.027L6.461,12.854a.938.938,0,0,1,1.324-1.328Z",
    transform: "translate(-6.204 -11.247)",
    fill: "#525252"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDropDownArrow);
export default __webpack_public_path__ + "static/media/drop-down-arrow.c052120847dc35eaca0d82493c4c1454.svg";
export { ForwardRef as ReactComponent };